import { useSegmentIdentityTracking } from './hooks/useSegmentIdentityTracking/useSegmentIdentityTracking'
import { useSetFacebookFbcCookie } from './hooks/useSetFacebookFbcCookie/useSetFacebookFbcCookie'

interface SegmentIdentityTrackingProps {
  profileId: string
}
// SegmentIdentityTracking component is a wrapper around useSegmentIdentityTracking, so it can be used inside App.tsx
// It component should be rendered inside ApolloProvider
export const SegmentIdentityTracking: React.FC<SegmentIdentityTrackingProps> = ({ profileId }) => {
  useSetFacebookFbcCookie()
  useSegmentIdentityTracking(profileId)
  return null
}
